import axios from "axios";
import baseURL from "./../api";
class NotificationsService {

    getNotifications(filterData, pageNumber, rowsPage) {
       
        let formattedStartDate ='';
        let formattedEndDate = '';
        let paymentType = '';
       
        if(filterData.start_date) {
            const startDate = filterData.start_date; 
            const parts = startDate.split('-');
            formattedStartDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
          }
          if(filterData.end_date) {
            const startDate = filterData.end_date; 
            const parts = startDate.split('-');
            formattedEndDate = `${parts[2]}-${parts[1]}-${parts[0]}`;
          }
          if(filterData.paymentType) {
            paymentType = filterData.paymentType.toUpperCase();
          }
         
        
          return axios.get(`${baseURL}/notifications?fromDate=${formattedStartDate}&toDate=${formattedEndDate}&transactionType=${paymentType}&page=${pageNumber}&size=${rowsPage}`);

    }

}
export default new NotificationsService();